<template>
  <v-form ref="form" v-model="valid" @keyup.native.enter="valid && submit($event)">
    <v-text-field
      v-model="username"
      :rules="usernameRules"
      :label="this.$store.getters['translate/translater']
      .__('Username', 'users')"
      required
    ></v-text-field>
    <v-flex xs12 sm12 d-flex>
	    <v-select
	      v-model="selected"		
	      :items="roles"
	      :label="this.$store.getters['translate/translater']
      		.__('Role', 'users')"
	      item-text="text"
	      item-value="value"
	    ></v-select>
	</v-flex>
    
    <v-btn small
      :disabled="!valid"
      class="success"
      @click="submit"
    >
    
      {{this.$store.getters['translate/translater']
      .__('Save')}}
    </v-btn>

    <v-btn small
      
      
      @click="cancel"
    >
    
      {{this.$store.getters['translate/translater']
      .__('Cancel')}}
    </v-btn>
  </v-form>
</template>

<script>

	import {usernameRules} from '../../validation/users'
  	import {passwordRules} from '../../validation/users'
  	import {capitalizeFirstLetter} from '../../tools'
  	import {translater} from '../../tools/translate';


	export default {



		data()
		{
			return {
				valid: false,
				
				
				usernameRules: usernameRules,
				
			}
		},

		created()
		{
			
			this.$store.dispatch('users/getEdit', this.$route.params.id)

		},

		beforeRouteLeave(to, from , next)
		{
			this.$store.dispatch('users/flush');
			next();
		},

		methods: {
			submit(){
				if (this.$refs.form.validate()) {
					this.$store.dispatch('error/setErrors', []);
					this.$store.dispatch('users/update')
					.then((res) => {
						this.$router.push('/users');
						this.$store.dispatch(
							'success/setMessage', 
							translater.__('User updated successfully', 'users')
						);

						setTimeout(() => {
							this.$store.dispatch('success/setMessage', undefined)
						}, 5000)
					})
					.catch((err) => {
						if(err.response.data.errors){
							let errors = Object.keys(err.response.data.errors).map((f) => {
								return capitalizeFirstLetter(
									translater.__(err.response.data.errors[f].message)
								);
							});

							this.$store.dispatch('error/setErrors', errors);
						} else {
							this.$store.dispatch('error/setError', translater.__("Error updating user"))
						} 
					})
				}
			},
			cancel(){
				this.$store.dispatch('error/setErrors', [])
				this.$router.push({name: 'usersIndex'})
			}
		},

		computed: {
			username: {
				get : function(){ return this.$store.getters['users/get'].username },
				set: function(value) { this.$store.dispatch('users/setUsername', value) }
			},

			roles: {
				get: function()
				{
					return this.$store.getters['users/roles'];
				}
			},

			selected: {
				get: function(){
					return this.$store.getters['users/role']
				},

				set: function(value)
				{
					this.$store.dispatch('users/setRole', value)
				}
			}
		}
	}
</script>